import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { createSearchParams } from 'react-router';

export function clearFiltersExtraReducer<T>(
  builder: ActionReducerMapBuilder<T>
) {
  return builder.addMatcher(
    (action) => {
      const type: string = action.type;
      return type.includes('clearFilters');
    },
    (state) => {
      const current = new URLSearchParams(window.location.search);
      const ordering = current.get('ordering');
      const next = ordering
        ? createSearchParams({ ordering })
        : new URLSearchParams();

      if (next.toString() !== current.toString()) {
        window.history.pushState(
          null,
          '',
          `${window.location.pathname}?${next.toString()}`
        );
      }

      return state;
    }
  );
}
